import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a8acbe6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row login" }
const _hoisted_2 = { class: "col-md-6 offset-md-3 d-flex flex-column justify-content-center align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, null, -1))
const _hoisted_4 = { class: "form-group text-start my-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "emailInput",
  class: "mg-label"
}, "Identifiant", -1))
const _hoisted_6 = { class: "form-group text-start my-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "passwordInput",
  class: "mg-label"
}, "Mot de passe", -1))
const _hoisted_8 = {
  key: 0,
  type: "button",
  class: "btn btn-primary my-2 mg-button disabled"
}
const _hoisted_9 = { class: "text-primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_loader = _resolveComponent("the-loader")!
  const _component_the_dialog_change_password = _resolveComponent("the-dialog-change-password")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            id: "emailInput",
            type: "text",
            class: "form-control mg-input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userInput.email) = $event)),
            onKeypress: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onKeyPress && _ctx.onKeyPress(...args)))
          }, null, 544), [
            [_vModelText, _ctx.userInput.email]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            id: "passwordInput",
            type: "password",
            class: "form-control mg-input",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userInput.password) = $event)),
            onKeypress: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onKeyPress && _ctx.onKeyPress(...args)))
          }, null, 544), [
            [_vModelText, _ctx.userInput.password]
          ])
        ]),
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("button", _hoisted_8, [
              _createVNode(_component_the_loader, { class: "loader-position" })
            ]))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "btn btn-primary my-2 mg-button",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)))
            }, "Connexion")),
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.errorLogin), 1)
      ])
    ]),
    (_ctx.isDialogChangePasswordVisible)
      ? (_openBlock(), _createBlock(_component_the_dialog_change_password, {
          key: 0,
          message: 'Vous devez changer votre mot de passe',
          textButtonCancel: 'Annuler',
          textButtonValidation: 'Valider',
          onDialogclosecancel: _ctx.hideDialogChangePassword,
          onDialogclosevalid: _ctx.checkUser
        }, null, 8, ["onDialogclosecancel", "onDialogclosevalid"]))
      : _createCommentVNode("", true)
  ], 64))
}